<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 mb-4">
      <h2 class="mb-2 mx-n2 text-center">Forgot your Password?</h2>
      Enter the email associated with your account
      and we will send you a password recovery code.
    </div>
    <v-form ref="form" @submit.prevent="codeClick">
      <v-text-field 
        v-model="email"
        outlined dense hide-details="auto"
        class="mt-3"
        label="Email"
        placeholder=" " persistent-placeholder
        :rules="[ required ]"
        validate-on-blur
        autocomplete="off" autocapitalize="none"
      />

      <div class="mt-6 d-flex justify-center">
        <v-btn width="60%" type="submit" color="primary">Next</v-btn>
      </div>

    </v-form>

    <div class="ml-3 mt-3 text-center">
      <a style="text-decoration: underline;" @click="$router.back()">Back to Login</a>
    </div>
  </div>
</template>
<script>

import { mapMutations } from 'vuex'
import { required } from '@/lib/validations'

export default {
  name: 'RecoverView',

  data: () => ({
    email: '',

    // validations
    required,
  }),

  methods: {
    ...mapMutations('auth', ['SET_UNVERIFIED_USER']),

    async codeClick() {
      if (this.$refs.form.validate()) {
        let id = this.email.trim()
        this.SET_UNVERIFIED_USER(id)
        this.$router.replace({ name: 'recover/methods' })
      }
    },
  },
}
</script>